module.exports = __webpack_public_path__ + "img/coming_soon.8761e506.jpg";